module.exports = __webpack_public_path__ + "img/report-sample-05@3x.206f2827.png";